<template>
    <div class="column-pagination d-flex align-items-center">
        <span class="mr-2">Page {{ fieldPagination.current_page }} of {{ fieldPagination.total_pages }} |
            Columns {{ startColumn }}-{{ endColumn }} of {{ fieldPagination.total_count }}</span>
        <div class="d-flex" style="gap: 10px;">
            <!-- First Page Button -->
            <v-icon size="22" dense
                :style="{ color: canGoPrev ? '#007BFF' : '#BDBDBD', cursor: canGoPrev ? 'pointer' : 'default' }"
                @click="goToPage(1)">
                mdi-page-first
            </v-icon>

            <!-- Previous Button -->
            <v-icon size="22" dense
                :style="{ color: canGoPrev ? '#007BFF' : '#BDBDBD', cursor: canGoPrev ? 'pointer' : 'default' }"
                @click="goToPage(fieldPagination.current_page - 1)">
                mdi-chevron-left
            </v-icon>

            <!-- Next Button -->
            <v-icon size="22" dense
                :style="{ color: canGoNext ? '#007BFF' : '#BDBDBD', cursor: canGoNext ? 'pointer' : 'default' }"
                @click="goToPage(fieldPagination.current_page + 1)">
                mdi-chevron-right
            </v-icon>

            <!-- Last Page Button -->
            <v-icon size="22" dense
                :style="{ color: canGoNext ? '#007BFF' : '#BDBDBD', cursor: canGoNext ? 'pointer' : 'default' }"
                @click="goToPage(fieldPagination.total_pages)">
                mdi-page-last
            </v-icon>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';

export default {
    name: 'ScheduledReportColumnPagination',
    props: {
        templateId: {
            type: [String, Number],
            required: true
        }
    },
    computed: {
        ...mapGetters({
            fieldPagination: 'reportTemplates/fieldPagination',
            selectedColumns: 'reportTemplates/selectedColumns',
            hasUnsavedChanges: 'reportTemplates/hasUnsavedChanges',
        }),
        canGoPrev() {
            return this.fieldPagination.current_page > 1;
        },
        canGoNext() {
            return this.fieldPagination.current_page < this.fieldPagination.total_pages;
        },
        startColumn() {
            return (this.fieldPagination.current_page - 1) * this.fieldPagination.per_page + 1;
        },
        endColumn() {
            return Math.min(this.startColumn + this.fieldPagination.per_page - 1, this.fieldPagination.total_count);
        },
    },
    methods: {
        ...mapActions({
            getReportFields: 'reportTemplates/getReportFields',
        }),
        ...mapMutations({
            setPagination: 'reportTemplates/setFieldPagination',
        }),
        goToPage(page) {
            if (page < 1 || page > this.fieldPagination.total_pages) return;

            if (this.hasUnsavedChanges) {
                this.setPagination({
                    current_page: page,
                    per_page: this.fieldPagination.per_page,
                    total_count: this.selectedColumns.length,
                    total_pages: Math.ceil(this.selectedColumns.length / this.fieldPagination.per_page),
                });
            } else {
                this.setPagination({
                    current_page: page,
                    per_page: this.fieldPagination.per_page,
                });

                if (this.templateId) {
                    this.getReportFields(this.templateId);
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.column-pagination {
    color: #3F3F3F;
    font-size: 14px;
}
</style>
